import React from 'react';
import {QueryClientProvider} from "react-query";
import {queryClient} from "services/query-client";
import {OperatorProvider} from "context/OperatorContext";
import {AuthProvider} from "context/AuthContext";
import {NotificationProvider} from "context/NotificationContext";
import {BrowserRouter as Router} from "react-router-dom";
import Routes from "pages/Routes";
import NotificationCentre from "components/NotificationCentre";
import {HelmetProvider} from "react-helmet-async";
import * as Sentry from "@sentry/react";
import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from "chart.js";
import ErrorBoundaryFallback from "../ErrorBoundaryFallback";
import {ReactQueryDevtools} from 'react-query/devtools'

ChartJS.register(ArcElement, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Title, Legend);

function App() {
  return (
    <Sentry.ErrorBoundary fallback={props => <ErrorBoundaryFallback {...props}/>} showDialog>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <OperatorProvider>
            <AuthProvider>
              <NotificationProvider>
                <Router>
                  <Routes/>
                </Router>

                <NotificationCentre/>
              </NotificationProvider>
            </AuthProvider>
          </OperatorProvider>
          <ReactQueryDevtools initialIsOpen={false} position='bottom-right'/>
        </QueryClientProvider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
